import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start with 17 mins 33 secs = 1053 seconds
  const INITIAL_TIME = 17 * 60 + 33;
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          return INITIAL_TIME; // Reset
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const units = [{
    value: hours,
    label: 'Horas'
  }, {
    value: minutes,
    label: 'Minutos'
  }, {
    value: seconds,
    label: 'Segundos'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="my-8 mx-auto max-w-xl rounded-3xl bg-[#5d4a6e] p-6 md:p-8 shadow-2xl border-4 border-[#c9a24b] text-center" data-id="element-1">
      <motion.div animate={{
      scale: [1, 1.06, 1]
    }} transition={{
      duration: 1.4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="inline-flex items-center gap-2 bg-[#c08a92] text-white font-black uppercase tracking-wider px-5 py-2 rounded-full mb-5 text-sm md:text-base shadow-md" data-id="element-2">
        <Clock size={18} className="shrink-0" data-id="element-3" />
        ¡Esta oferta termina pronto!
      </motion.div>

      <div className="flex items-start justify-center gap-3 md:gap-5" data-id="element-4">
        {units.map((unit, i) => <Fragment key={unit.label} data-id="element-5">
            <div className="flex flex-col items-center" data-id="element-6">
              <div className="bg-white text-[#5d4a6e] text-4xl md:text-6xl font-black rounded-2xl w-20 h-20 md:w-28 md:h-28 flex items-center justify-center shadow-[0_6px_0_#c9a24b] tabular-nums" data-id="element-7">
                {unit.value.toString().padStart(2, '0')}
              </div>
              <span className="text-xs md:text-sm text-[#f0d99a] mt-3 font-bold uppercase tracking-widest" data-id="element-8">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="text-4xl md:text-6xl font-black text-[#c9a24b] mt-4 md:mt-6 animate-pulse" data-id="element-9">
                :
              </span>}
          </Fragment>)}
      </div>

      <p className="text-white/90 mt-6 text-sm md:text-base font-medium" data-id="element-10">
        Asegura tu{' '}
        <span className="text-[#f0d99a] font-bold" data-id="element-11">Kit + 7 bonos GRATIS</span>{' '}
        antes de que el tiempo llegue a cero.
      </p>
    </motion.div>;
}